import React from "react"
import { createRoot } from "react-dom/client"

import App from "./app"
import reportWebVitals from "./reportWebVitals"
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const container = document.getElementById("root")
const root = createRoot(container)

try {
  root.render(<App />)
} catch (err) {
  root.render('Ooops, something went wrong, try clearing your browsers local storage and refreshing the page')
  console.error(err)
}

serviceWorkerRegistration.unregister();

reportWebVitals();
